<template>
  <component
    :is="Transition"
    v-bind="bindings"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { mergeProps, Transition, useAttrs } from 'vue'
import { getTransitionClasses } from './utils'
import type { TransitionTiming, TransitionVariant } from './types'

const props = withDefaults(defineProps<{
  timing?: TransitionTiming
  variant?: TransitionVariant
  isDisabled?: boolean
}>(), {
  timing: 'normal',
  variant: 'fade',
})

defineOptions({ inheritAttrs: false })

const attrs = useAttrs()

// We disable transitions in-place to avoid destroying and recreating the child
// with a v-if/v-else on a component/slot.
const bindings = computed(() => {
  const base = mergeProps(attrs, getTransitionClasses(props.variant, props.timing))

  if (!props.isDisabled) {
    return base
  }

  return mergeProps(base, {
    css: false,
    enterActiveClass: '',
    enterFromClass: '',
    leaveActiveClass: '',
    leaveToClass: '',
  })
})
</script>
